import { useQuery } from '@tanstack/react-query';
import { InsuranceLineSearchResponse, InsuranceLineSearchRequestQuery } from '@lio/api-types';
import { useClient } from '@utils/api-client';

const config = {
  staleTime: 60000,
};

export const useInsuranceLines = ({
  jurisdictionIds,
  writingCompanyId,
  sort,
  pageLimit,
}: InsuranceLineSearchRequestQuery) => {
  const client = useClient();
  const queryParams = new URLSearchParams();
  if (writingCompanyId) {
    queryParams.append('writingCompanyId', writingCompanyId);
  }
  if (jurisdictionIds) {
    jurisdictionIds.forEach((id) => queryParams.append('jurisdictionIds', id));
  }

  if (sort) {
    queryParams.append('sort', sort);
  }

  if (pageLimit) {
    queryParams.append('pageLimit', pageLimit?.toString());
  }

  const requestUrl = `insurance-line${queryParams.toString() === '' ? '' : '?'}${queryParams}`;
  const result = useQuery<InsuranceLineSearchResponse, Error>({
    queryKey: ['insurance-line', { jurisdictionIds, writingCompanyId }],
    queryFn: async () => {
      const response = await client.get(requestUrl).json<InsuranceLineSearchResponse>();
      return response;
    },
    ...config,
  });
  return { ...result, insuranceLines: result.data };
};
